var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGritLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "27px",
    viewBox: "0 0 214 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GRIT_DIGITAL_HEALTH_logo_horizontal_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "34.8859653%",
    y1: "53.1612237%",
    x2: "65.1140347%",
    y2: "46.8387763%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B87A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38B690",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16B1C9",
    offset: "71%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADEE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GDH-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    transform: "translate(-205.000000, -36.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GRIT_DIGITAL_HEALTH_logo_horizontal_RGB",
    transform: "translate(205.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E81A47",
    x: 37.7280315,
    y: 0,
    width: 2.31692913,
    height: 2.31692913
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-1)",
    points: "42.1765354 0.244330709 42.1765354 2.1442126 211.990591 2.1442126 211.990591 24.1718898 1.89988189 24.1718898 1.89988189 2.1442126 33.4817323 2.1442126 33.4817323 19.1631102 35.5501181 19.1631102 35.5501181 0.564488189 35.5416929 0.564488189 35.5416929 0.244330709 0 0.244330709 0 26.0717717 213.890472 26.0717717 213.890472 0.244330709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6209449,14.2259449 L15.6118898,14.2259449 L15.6118898,16.4291339 C14.7843181,17.0207978 13.7898551,17.3335962 12.7725984,17.3222047 C10.3672047,17.3222047 8.76641732,15.5402756 8.76641732,13.1096063 C8.76641732,10.8221654 10.4177559,8.93492126 12.5872441,8.93492126 C13.8096556,8.90157836 14.9950368,9.35632819 15.8814961,10.1987008 L17.1958268,8.63582677 C15.9548076,7.53157408 14.3308363,6.95698458 12.6714961,7.03503937 C11.048616,7.01542541 9.48695027,7.6537798 8.34249599,8.80458333 C7.19804172,9.95538687 6.56833695,11.5205604 6.59692913,13.1433071 C6.59692913,16.5892126 9.01917323,19.2136614 12.7051969,19.2136614 C14.5095794,19.2133621 16.2534151,18.5627887 17.6170866,17.3811811 L17.6170866,12.4271654 L12.6209449,12.4271654 L12.6209449,14.2259449 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3180709,10.9653937 C30.3180709,8.66110236 28.6330315,7.2288189 25.9411811,7.2288189 L20.6922835,7.2288189 L20.6922835,19.0030315 L22.7733071,19.0030315 L22.7733071,14.8999606 L25.3640551,14.8999606 L28.2538976,19.0030315 L30.6929921,19.0030315 L27.5082677,14.5671654 C29.1553937,14.0911417 30.3180709,12.9158268 30.3180709,10.9653937 Z M22.7648819,13.0716929 L22.7648819,9.11606299 L25.7726772,9.11606299 C27.306063,9.11606299 28.2117717,9.79007874 28.2117717,11.0833465 C28.2117717,12.2965748 27.2723622,13.0716929 25.7895276,13.0716929 L22.7648819,13.0716929 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "38.5368504 9.14555118 42.2692126 9.14555118 42.2692126 19.0030315 44.3544488 19.0030315 44.3544488 9.14555118 48.0910236 9.14555118 48.0910236 7.2288189 38.5368504 7.2288189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9504724,7.2288189 L57.5735827,7.2288189 L57.5735827,19.0030315 L61.9504724,19.0030315 C65.6491339,19.0030315 68.2061811,16.4291339 68.2061811,13.1053937 C68.2061811,9.78165354 65.6659843,7.2288189 61.9504724,7.2288189 Z M61.9504724,17.12 L59.6293307,17.12 L59.6293307,9.11606299 L61.9504724,9.11606299 C64.4232677,9.11606299 66.0366929,10.8011024 66.0366929,13.1390945 C66.0366929,15.4770866 64.4401181,17.12 61.9504724,17.12 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 70.7716535,
    y: 7.2288189,
    width: 2.06838583,
    height: 11.7742126
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.749685,14.2259449 L84.7616929,14.2259449 L84.7616929,16.4291339 C83.9325595,17.0208574 82.936751,17.333615 81.918189,17.3222047 C79.5127953,17.3222047 77.9162205,15.5402756 77.9162205,13.1096063 C77.9162205,10.8221654 79.5633465,8.93492126 81.7328346,8.93492126 C82.9560551,8.90416592 84.1417898,9.3584704 85.0312992,10.1987008 L86.3414173,8.63582677 C85.1008642,7.53078552 83.4765604,6.95607842 81.8170866,7.03503937 C80.1942066,7.01542541 78.6325408,7.6537798 77.4880865,8.80458333 C76.3436323,9.95538687 75.7139275,11.5205604 75.7425197,13.1433071 C75.7425197,16.5892126 78.1647638,19.2136614 81.8507874,19.2136614 C83.65517,19.2133621 85.3990057,18.5627887 86.7626772,17.3811811 L86.7626772,12.4271654 L81.749685,12.4271654 L81.749685,14.2259449 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 90.0316535,
    y: 7.2288189,
    width: 2.06838583,
    height: 11.7742126
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.696063,7.14456693 L104.497717,19.0030315 L106.604016,19.0030315 L107.817244,16.1637402 L113.386299,16.1637402 L114.578465,19.0030315 L116.764803,19.0030315 L111.583307,7.14456693 L109.696063,7.14456693 Z M108.605,14.3270472 L110.622835,9.6173622 L112.65752,14.3270472 L108.605,14.3270472 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "121.402874 7.2288189 119.330276 7.2288189 119.330276 19.0030315 127.591181 19.0030315 127.591181 17.12 121.402874 17.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "104.590394 9.14555118 104.590394 7.2288189 95.0362205 7.2288189 95.0362205 9.14555118 98.7685827 9.14555118 98.7685827 19.0030315 100.853819 19.0030315 100.853819 9.14555118"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "143.784409 12.326063 138.169016 12.326063 138.169016 7.43102362 136.096417 7.43102362 136.096417 19.2052362 138.169016 19.2052362 138.169016 14.2427953 143.784409 14.2427953 143.784409 19.2052362 145.852795 19.2052362 145.852795 7.43102362 143.784409 7.43102362"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "151.472402 14.1922441 157.374252 14.1922441 157.374252 12.3429134 151.472402 12.3429134 151.472402 9.28035433 158.13252 9.28035433 158.13252 7.43102362 149.399803 7.43102362 149.399803 19.2052362 158.216772 19.2052362 158.216772 17.3559055 151.472402 17.3559055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.73626,7.34677165 L160.554764,19.2010236 L162.661063,19.2010236 L163.870079,16.3575197 L169.455984,16.3575197 L170.635512,19.2010236 L172.82185,19.2010236 L167.644567,7.34255906 L165.73626,7.34677165 Z M164.645197,14.529252 L166.663031,9.81956693 L168.697717,14.529252 L164.645197,14.529252 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "177.590512 7.43102362 175.522126 7.43102362 175.522126 19.2052362 183.783031 19.2052362 183.783031 17.3222047 177.590512 17.3222047"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "203.805512 7.43102362 203.805512 12.326063 198.185906 12.326063 198.185906 7.43102362 196.11752 7.43102362 196.11752 19.2052362 198.185906 19.2052362 198.185906 14.2427953 203.805512 14.2427953 203.805512 19.2052362 205.873898 19.2052362 205.873898 7.43102362"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "183.749331 9.34775591 187.481693 9.34775591 187.481693 19.2052362 189.566929 19.2052362 189.566929 9.34775591 193.303504 9.34775591 193.303504 7.43102362 183.749331 7.43102362"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGritLogo);
export default __webpack_public_path__ + "static/media/grit-logo.b5e5cc1beead50b524b58a89ba4c23a0.svg";
export { ForwardRef as ReactComponent };